const localeText = {
  // Set Filter
  selectAll: 'Tout sélectionner',
  selectAllSearchResults: 'Select All Search Results',
  searchOoo: 'Recherche...',
  blanks: 'Blanks',
  noMatches: 'Aucun résultat.',

  // Number Filter & Text Filter
  filterOoo: 'Filtrer...',
  equals: 'Égal à',
  notEqual: 'Différent de',
  // Number Filter
  lessThan: 'Moins que',
  greaterThan: 'Plus que',
  lessThanOrEqual: 'Moins que ou égal à',
  greaterThanOrEqual: 'Plus que ou égal à',
  inRange: 'Entre',
  inRangeStart: '',
  inRangeEnd: 'et',

  // columns tool panel
  rowGroupColumnsEmptyMessage: 'Faites glisser ici pour regrouper les lignes',

  // Other
  noRowsToShow: 'Aucun produit trouvé',
};

export default localeText;
